import { Spin } from 'antd';
import styled from 'styled-components';

export const FullPageLoader = styled(Spin)`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
